import { makeObservable } from '../../../utils/makeObservable';

export const isGTMScriptLoaded = makeObservable<boolean>(false);
